import { jsx as _jsx } from "react/jsx-runtime";
import { toClassName } from '../../utils/ClassNameUtils.js';
import { toFlexContainerClassName, toFlexItemClassName, } from '../../utils/FlexboxUtils.js';
import { toSpacingClassName } from '../../utils/LayoutPropsUtils.js';
export const Row = ({ className, style, children, ...props }) => {
    return (_jsx("div", { className: toClassName(className, toFlexContainerClassName({ ...props, flexDirection: 'row' }), toSpacingClassName(props)), style: style, children: children }));
};
Row.displayName = 'Row';
Row.Item = ({ className, style, children, ...props }) => {
    return (_jsx("div", { className: toClassName(className, toFlexItemClassName(props)), style: style, children: children }));
};
Row.Item.displayName = 'Row.Item';
//# sourceMappingURL=Row.js.map